/**
 * THE MODIFICATIONS MODULE'S DOOR (desk, 2026-10-07: "this should show only who have approve access under Administration →
 * Approver. Even super admin and administrator can't see this module.")
 *
 * Every other module is a ROLE grant: `role_modules` rows put a code in the login token's `moduleCodes`, and the SuperAdmin and
 * System Administrator hold all of them. A module opened the same way would open for exactly the people this one must stay shut
 * to. So Modifications is not a role module at all:
 *
 *   - `MODIFICATIONS` is not in `NAV_MODULE_CODES`, so no role can be granted it from Administration → Roles;
 *   - it is added to the user's module codes HERE, only while the server says they are a selected approver
 *     (`GET /financial/correction-workflow/me` → `isApprover`, read from the selection as it is NOW, not from the token);
 *   - whatever the token carries under that name is thrown away first, so a stray `role_modules` row cannot open it either.
 *
 * Everything that offers or opens the module — the workspace switcher, the sidebar, global search, the route — reads its codes
 * through `withModificationsAccess`, so they cannot disagree. The server decides again on every request
 * (`CorrectionWorkflowService.assertApprover`); this only avoids showing a door the server is bound to refuse.
 */
export const MODIFICATIONS_MODULE = 'MODIFICATIONS';

export function withModificationsAccess(moduleCodes: readonly string[], isApprover: boolean): string[] {
  const rest = moduleCodes.filter((code) => code !== MODIFICATIONS_MODULE);
  return isApprover ? [...rest, MODIFICATIONS_MODULE] : rest;
}
